// src/pages/MyEssence/MyEssence.js
import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';

function MyEssence() {
  const [essens, setEssens] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEssens = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user) {
        const docRef = doc(db, 'kodeessens', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setEssens({ ...docSnap.data(), uid: user.uid }); // ✅ inkluder uid
        }
      }
    };
    fetchEssens();
  }, []);

  if (!essens) {
    return (
      <div className="min-h-screen bg-white text-black flex items-center justify-center">
        <p>❌ Ingen Kode-Essens™ funnet.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white text-black py-12 px-4">
      <h1 className="text-2xl font-bold text-center mb-6">Min Kode-Essens™</h1>
      <div className="max-w-md mx-auto bg-gray-100 p-6 rounded-lg shadow">
        <p><strong>Kodeord:</strong> {essens.kodeord}</p>
        <p><strong>Kjennetegn:</strong> {essens.kjennetegn}</p>
        <p><strong>Essens-setning:</strong> {essens.essensSetning}</p>
        <p><strong>Tilkallingsformel:</strong> {essens.tilkallingsformel}</p>

        <button
          className="mt-6 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full"
          onClick={() =>
            navigate('/create-essens', {
              state: {
                kodeord: essens.kodeord,
                kjennetegn: essens.kjennetegn,
                essensSetning: essens.essensSetning,
                tilkallingsformel: essens.tilkallingsformel,
              },
            })
          }
        >
          Rediger Kode-Essens™
        </button>
      </div>
    </div>
  );
}

export default MyEssence;